import React, { useEffect, useState } from "react";
import { Modal, Button } from "react-bootstrap";
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  CardHeader,
  CardTitle,
} from "reactstrap";
import { connect } from "react-redux";
import { setBreadcrumbItems } from "../../store/actions";
import Spinners from "components/Common/Spinner";
import * as url from "../../helpers/url_helper";
import "flatpickr/dist/themes/material_blue.css";
import { MDBDataTable } from "mdbreact";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";

const LocationList = (props) => {
  document.title = "Location List - VUF";
  const [isLoading, setLoading] = useState(false);
  const breadcrumbItems = [
    { title: "VUF", link: "#" },
    { title: "Location List", link: "#" },
  ];
  const [showModal, setShowModal] = useState(false);
  const [LocationList, setLocationList] = useState([]);
  const [reportList, setReportList] = useState([]);
  const [socialMediaList, setSocialMediaList] = useState([]);
  const [type, setType] = useState("");
  const state = {
    isLoading: false,
    errors: {},
    ResErrors: {},
    isRedirect: false,
    sangathanId: null,
    country_code: "+91",
    ccode: "+91",
    email: "",
    mobileNo: "",
    remark: "",
    assignRole: "",
    firstName: "",
    lastName: "",
    country: "",
    state: "",
    city: "",
    RegistrationLinkToCopy: url.CurrentUrl + "register/",
    OtherLink: url.CurrentUrl + "?link=",
    QRLink: url.VUF_URL + "?l=",
    QRCodeValue: "ABCD12345",
    locations: [],
    counts: {
      totalUsers: 0,
      mainApp: 0,
      gbnApp: 0,
      sangathanApp: 0,
      eventUsers: 0,
      locationUsers: 0,
    },
    selectionRange: {
      startDate: new Date(),
      endDate: new Date(),
      key: "selection",
    },

    showDatePicker: false,
  };

  useEffect(() => {
    props.setBreadcrumbItems("List", breadcrumbItems);
  });
  useEffect(() => {
    getLocation();
  }, []);

  function getLocation() {
    setLoading(true);
    let urlPath = "location/get-location-list/";

    fetch(url.VUF_APP_API + urlPath, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    })
      .then((response) => response.json())
      .then((responseData) => {
        if (responseData.status) {
          setLocationList(responseData.data);
        } else {
          alert("Something went wrong, Please try again after sometime.");
        }
        setLoading(false);
      })
      .catch((error) => {
        console.log("err", error);
        alert("Something went wrong, Please try again after sometime.");
      })
      .finally((final) => {
        setLoading(false);
      });
  }
  function GetOtherLink() {
    setLoading(true);
    let urlPath = "location/get-location-list/";

    fetch(url.VUF_APP_API + urlPath, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    })
      .then((response) => response.json())
      .then((responseData) => {
        if (responseData.status) {
          setLocationList(responseData.data);
        } else {
          alert("Something went wrong, Please try again after sometime.");
        }
        setLoading(false);
      })
      .catch((error) => {
        console.log("err", error);
        alert("Something went wrong, Please try again after sometime.");
      })
      .finally((final) => {
        setLoading(false);
      });
  }
  const handleViewDetails = (id, type) => {
    setShowModal(true);
    let urlPath = `location/get-report/${id}/${type}`;

    fetch(url.VUF_APP_API + urlPath, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    })
      .then((response) => response.json())
      .then((responseData) => {
        if (responseData.status) {
          const response = responseData.data;
          const responseType = responseData.type;
          let data;
          if (responseType === "count") {
            data = response.flatMap((item) =>
              item.clicks.map((clickEntry) => ({
                locationId: item.locationId,
                date: clickEntry.date,
                count: clickEntry.count,
                platform: clickEntry.platform,
                totalLinkCount: item.link_count, // Accessing parent data
              })),
            );
            setReportList(data);
          } else {
            const locationId = response._id;
            data = response.otherLinks.map((socialMedia) => ({
              platform: socialMedia.platform,
              url: socialMedia.url,
              id: socialMedia._id,
            }));
            setSocialMediaList({
              links: data,
              locationId: locationId,
            });
          }
          setType(responseType);
        } else {
          toast.error("Something went wrong, Please try again after sometime.");
        }
        setLoading(false);
      })
      .catch((error) => {
        console.log("err", error);
        toast.error("Something went wrong, Please try again after sometime.");
      })
      .finally((final) => {
        setLoading(false);
      });
    //navigate(`/details/${id}`, { state: { info: data } });
  };

  function handleDeleteClick(e, event) {
    const confirmDelete = window.confirm(
      "Are you sure you want to delete this location?",
    );
    if (confirmDelete) {
      // Delete the item or perform the desired action
      state.deleteItemId = event._id;
      onCheckDelete(e, event._id);

      console.log("Item deleted.");
    } else {
      console.log("Deletion canceled.");
    }
  }
  function onCheckDelete(e, location) {
    e.preventDefault();

    // const { signOut } = this.context;

    state.isLoading = true;
    state.itemDeleteLoading = true;

    let urlPath = "location/DeleteLocation/" + location;

    fetch(url.VUF_APP_API + urlPath, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    })
      .then((response) => response.json())
      .then(async (responseData) => {
        if (responseData.status) {
          alert("Location Removed Successfully.");
          getLocation();
        } else if (!responseData.status && responseData.error) {
          alert(responseData?.error || "Error");
        } else {
          alert("Something went wrong, Please try again after sometime.");
        }
      })
      .catch((error) => {
        console.log("err", error);
        alert("Something went wrong, Please try again after sometime.");
      })
      .finally((final) => {});
  }

  const formattedEventList = LocationList.map((location) => ({
    ...location,
    QRScanCount: location?.totalScans ? location?.totalScans : 0,
    city:
      location.city != undefined
        ? [location.city, ",", location.state, ",", location.country]
        : "",
    RegLink: [
      <a
        data-toggle="tooltip"
        title="Copy Registration Link"
        className="btn btn-outline-warning btn-sm m-1 copylink "
        onClick={() => {
          navigator.clipboard.writeText(
            state.RegistrationLinkToCopy + `${location._id}`,
          );
        }}
      >
        <span className=" menu-icon fas fa fa-clone"></span>
      </a>,
    ],
    OtherLinks:
      location?.otherLinks && location.otherLinks.length > 0 ? (
        <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
          <button
            onClick={() => handleViewDetails(location._id, "social")}
            className="btn btn-outline-primary btn-sm rounded-pill"
          >
            {/* Fix: Display the count or platform names instead of the whole object */}
            <i className="bi bi-link-45deg me-1"></i>
            <span>{location.otherLinks.length} Social Links</span>
          </button>
        </div>
      ) : (
        <span className="text-muted small">No Links Added</span>
      ),
    LinkCount: location?.totalLink ? (
      <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
        <button
          onClick={() => handleViewDetails(location._id, "count")}
          className="btn btn-outline-primary"
        >
          <span>{location.totalLink}</span>
        </button>
      </div>
    ) : (
      "----"
    ),
    QRLink: [
      <a
        data-toggle="tooltip"
        title="QR Copy Link"
        className="btn btn-outline-warning btn-sm m-1 copylink "
        onClick={() => {
          navigator.clipboard.writeText(state.QRLink + `${location._id}`);
        }}
      >
        <span className=" menu-icon fas fa fa-clone"></span>
      </a>,
    ],
    Action: [
      <a
        href={`/LocationUsersList/${location.place_id}`}
        className="btn btn-outline-info btn-sm m-1 "
      >
        <span className="menu-text">
          <span className=" menu-icon fas fa fa-eye"></span>
        </span>
      </a>,
      <a
        href={`/LocationAdd/${location._id}`}
        data-toggle="tooltip"
        title="Edit Location"
        className="btn btn-outline-warning btn-sm m-1 "
      >
        <span className="menu-text">
          <span className=" menu-icon fas fa fa-pen"></span>
        </span>
      </a>,
      <button
        type="button"
        className="btn btn-outline-danger btn-sm m-1"
        onClick={(event) => {
          handleDeleteClick(event, location);
        }}
      >
        <span className=" menu-icon fas fa fa-trash"></span>
      </button>,
    ],
  }));
  const copyToClipboard = (social, locationId) => {
    const shareUrl = `${url.VUF_APP_API}location/link?locationId=${locationId}&linkId=${social.id}&otherLink=${social.url}`;

    navigator.clipboard
      .writeText(shareUrl)
      .then(() => toast.success("Link copied to clipboard!"))
      .catch((err) => console.error("Could not copy text: ", err));
  };

  const formattedLinkList = reportList.map((clickLink) => ({
    ...clickLink,
    linkCount: clickLink.count ? clickLink?.count : 0,
    date: clickLink?.date ? clickLink?.date : "",
  }));

  const formattedSocialList = (socialMediaList?.links ?? []).map((social) => ({
    ...social,
    platform: social.platform ? social?.platform : "",
    url: social?.url ? social?.url : "",
    linkId: social?._id ? social?._id : "",
    SocialMediaLinkCopy: (
      <button
        className="btn btn-sm btn-outline-secondary"
        onClick={() => copyToClipboard(social, socialMediaList.locationId)}
      >
        <i className="bi bi-clipboard"></i> Copy Link
      </button>
    ),
  }));

  const tableData = {
    columns: [
      {
        label: "Name",
        field: "name",
        sort: "asc",
        width: 23,
      },

      {
        label: "Address",
        width: 25,
        sort: "asc",
        field: "city",
      },
      {
        label: "QR Scan Count",
        width: 10,
        sort: "asc",
        field: "QRScanCount",
      },
      {
        label: "Link Count",
        width: 10,
        sort: "asc",
        field: "LinkCount",
      },
      {
        label: "Reg. Link",
        width: 10,
        sort: "asc",
        field: "RegLink",
      },
      {
        label: "Social Link",
        width: 10,
        sort: "asc",
        field: "OtherLinks",
      },
      {
        label: "QR Link",
        width: 10,
        sort: "asc",
        field: "QRLink",
      },
      {
        label: "Action",
        width: 18,
        sort: "asc",
        field: "Action",
      },
    ],
    rows: formattedEventList,
  };
  let socialMedia, LinkData;

  if (type === "social") {
    socialMedia = {
      columns: [
        {
          label: "Which Platform",
          field: "platform",
          sort: "asc",
          width: 23,
        },
        {
          label: "Social Link",
          field: "url",
          sort: "asc",
          width: 23,
        },
        {
          label: "Social Link Copy",
          field: "SocialMediaLinkCopy",
          sort: "asc",
          width: 23,
        },
      ],
      rows: formattedSocialList,
    };
  } else {
    LinkData = {
      columns: [
        {
          label: "Which Platform",
          field: "platform",
          sort: "asc",
          width: 23,
        },
        {
          label: "Date",
          field: "date",
          sort: "asc",
          width: 23,
        },
        {
          label: "Link Count",
          width: 10,
          sort: "asc",
          field: "linkCount",
        },
      ],
      rows: formattedLinkList,
    };
  }
  return (
    <React.Fragment>
      {isLoading ? (
        <Spinners />
      ) : (
        <Row>
          <Col xl="12">
            <Card>
              <CardHeader>
                <div className="row align-items-center">
                  <div className="col">
                    <CardTitle className="h4 mb-0">Location List</CardTitle>
                  </div>
                  <div className="col-auto">
                    <Link
                      to="/LocationAdd"
                      className="btn btn-outline-primary h5"
                    >
                      <span className="menu-text">
                        <i className="fa fa-plus me-1"></i> Location
                      </span>
                    </Link>
                  </div>
                </div>
              </CardHeader>
              <CardBody>
                <br />
                <div class="row">
                  <MDBDataTable
                    responsive
                    striped
                    bordered
                    data={tableData}
                    noBottomColumns={true}
                  />
                </div>
                <div className="row">
                  <Modal
                    size="lg"
                    centered
                    show={showModal}
                    backdrop="static"
                    keyboard={false}
                    onHide={() => setShowModal(false)}
                  >
                    <Modal.Header closeButton>
                      <Modal.Title>
                        {type == "count"
                          ? "Social Media Platform and Date Wise Details"
                          : "Social Link Details"}
                      </Modal.Title>
                    </Modal.Header>

                    <Modal.Body>
                      <div className="row">
                        <MDBDataTable
                          responsive
                          striped
                          bordered
                          data={type === "social" ? socialMedia : LinkData}
                          noBottomColumns={true}
                        />
                      </div>
                    </Modal.Body>
                    <Modal.Footer>
                      <Button
                        variant="secondary"
                        onClick={() => setShowModal(false)}
                      >
                        Close
                      </Button>
                    </Modal.Footer>
                  </Modal>
                </div>
              </CardBody>
            </Card>
          </Col>
        </Row>
      )}
    </React.Fragment>
  );
};

export default connect(null, { setBreadcrumbItems })(LocationList);
